import queryString from 'query-string';

import { DateRange, removeEmptyKeys } from '@app/utils';
import { SORT_DIRECTION, URLQuery } from '@app/constants';

import { SearchState, SelectedFacets, SORT_FIELD } from '../../constants';

const stringifySortState = (
  sortField: SORT_FIELD = SORT_FIELD.relevance,
  sortDirection: SORT_DIRECTION = SORT_DIRECTION.asc
) => {
  if (sortField === SORT_FIELD.relevance) {
    return '';
  }

  const sortPrefix = sortDirection === SORT_DIRECTION.desc ? '-' : '';

  return `${sortPrefix}${sortField}`;
};

export const stringifyFacetsForUrl = (selectedFacets?: SelectedFacets) =>
  selectedFacets &&
  queryString.stringify(selectedFacets, {
    arrayFormat: 'bracket-separator',
  });

export const stringifyPublicationYear = (publicationYear?: DateRange) =>
  publicationYear && queryString.stringify(removeEmptyKeys(publicationYear));

export const getURLState = ({
  query,
  option,
  sortField,
  sortDirection,
  facets,
  publicationYear,
  pageNumber,
  recordsPerPage,
}: Partial<SearchState>): URLQuery => {
  const sort = stringifySortState(sortField, sortDirection);

  return removeEmptyKeys({
    query,
    option,
    sort,
    publicationYear: stringifyPublicationYear(publicationYear),
    facets: stringifyFacetsForUrl(facets),
    pageNumber: pageNumber?.toString(),
    recordsPerPage: recordsPerPage?.toString(),
  });
};
